export default "__VITE_ASSET__DmpjUFs6__"